import Gallery from '../../src/legacy/Gallery';
export default Gallery;
